exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.select-paginate{\n    height: 26px !important;\n    max-width: 32px !important;\n    border: 0;\n}\n", ""]);

// exports
